import hairServiceImg from "../assets/images/hair-service.jpg";
import skinServiceImg from "../assets/images/skin-service.jpeg";
import wellnessServiceImg from "../assets/images/wellness-service.jpg";
import FadeInSection from "./FadeInSection";

function Services() {
	return (
		<div className="services-container">
			<div className="container">
				<FadeInSection animationType="fade-right">
					<h2>Services</h2>
					<hr />
					<div className="row mt-5 gy-4">
						<div className="col-md-4">
							<div className="services-card">
								<img src={hairServiceImg} alt="Hair service" />
								<h4>Hair</h4>
								<p className="secondary-font mb-0">
									Custom colour, balayage, precision cuts & styling.
								</p>
							</div>
						</div>
						<div className="col-md-4">
							<div className="services-card">
								<img src={skinServiceImg} alt="Skin service" />
								<h4>Skin</h4>
								<p className="secondary-font mb-0">
									Facials, advanced treatments, and glow rituals.
								</p>
							</div>
						</div>
						<div className="col-md-4">
							<div className="services-card">
								<img src={wellnessServiceImg} alt="Wellness service" />
								<h4>Wellness</h4>
								<p className="secondary-font mb-0">
									Scalp rituals, relaxation, and restorative care.
								</p>
							</div>
						</div>
					</div>
				</FadeInSection>
			</div>
		</div>
	);
}

export default Services;
